import { Button, Grid, Paper, TextField, Tooltip } from "@mui/material"
import { DataGrid } from "@mui/x-data-grid"
import React, { useEffect, useState, useRef } from "react"
import SelectValue from "src/components/select-value"
import ToggleButtonSelect from "src/components/toggle-button-select"
import EditableInput from "../components/editableInput"
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import PropTypes from 'prop-types'
import SimuladorService from "src/services/simulador-service"
import dayjs from "dayjs"
import { DATE_FORMAT_SHOW, DATE_TIME_HOUR_MINUTE_FORMAT_SHOW, DATE_FORMAT } from "src/utils/constants"
import { changeFormatedValue, formatDecimalCaseReplaceDot, formatStringToFloatDecimalCase, formatToFloat, formatToNumber } from "src/utils/format-decimal"
import TextFieldFormatCurrency from "src/components/text-field-format-currency"
import TextFieldFormatDate from "src/components/text-field-format-date"
import EditableNumberInput from "../components/editableNumberInput"
import SkeletonTable from "src/components/skeleton-table"
import { validaPreenchimentoCampo } from "src/utils/input-validator"

const SimuladorSubordinacaoSimulacao = (props) => {
    const percentilDefaultValue = 99
    const plCotasDefaultValue = 0
    const caixaDefaultValue = 0
    const caixaOriginalDefaultValue = 0
    const multiplicadorDefaultValue = 1
    const plCotasOriginalDefaultValue = 1
    const dataProcessamentoDefaultValue = dayjs().format(DATE_FORMAT_SHOW)

    const service = new SimuladorService()
    const [loadingTable, setLoadingTable] = useState(false)
    const [selectValue, setSelectValue] = useState({})
    const [selectItemList, setSelectItemList] = useState([])
    const [dataReferencia, setDataReferencia] = useState({})
    const [dataProcessamento, setDataProcessamento] = useState(dayjs().format(DATE_FORMAT_SHOW))

    const [volumeFinanceiro, setVolumeFinanceiro] = useState("")
    const [qtdOperacoes, setQtdOperacoes] = useState("")
    const [estoque, setEstoque] = useState(0)
    const [pddObservada, setPddObservada] = useState("")
    const [pddSugerida, setPddSugerida] = useState("")
    const [pddSelecionada, setPddSelecionada] = useState("")
    const [typePDDObservada, setTypePDDObservada] = useState(false)
    const [plCotasOriginal, setPlCotasOriginal] = useState(plCotasOriginalDefaultValue)
    const [plCotas, setPLCotas] = useState(plCotasDefaultValue)
    const [nomeCarteira, setNomeCarteira] = useState("")
    const [multiplicadorEditadoManualmente, setMultiplicadorEditadoManualmente] = useState(false)
    const [caixaEditadoManualmente, setCaixaEditadoManualmente] = useState(false)
    const [multiplicador, setMultiplicador] = useState(multiplicadorDefaultValue)
    const [percentil, setPercentil] = useState(percentilDefaultValue)
    const [caixa, setCaixa] = useState(caixaDefaultValue)
    const [caixaOriginal, setCaixaOriginal] = useState(caixaOriginalDefaultValue)
    const [tableKey, setTableKey] = useState(Math.random())
    const [plInput, setPlInput] = useState([])
    const [bodySimulacao, setBodySimulacao] = useState([])
    const [typeSimuladorTaxaAccrual, setTypeSimuladorTaxaAccrual] = useState(false)
    const [dadosCarregados, setDadosCarregados] = useState(false)
    const [dataProcessamentoError, setDataProcessamentoError] = useState("")

    const dataProcessamentoRef = useRef(null)

    // limpa o erro quando o usuário edita o campo de Data Processamento
    const handleDataProcessamentoChange = (newDate) => {
        setDataProcessamento(newDate)
        if (dataProcessamentoError) setDataProcessamentoError("")
    }

    const subordinationInitialState = [{
        id: 1,
        ID: 1,
        IDCarteiraLote_id: "",
        IDOperacao: "",
        DataReferencia: { value: "", show: "" },
        DataProcessamento: dayjs().format(DATE_FORMAT_SHOW),
        NomeCota: "Subordinação 1",
        PLCota: 0,
        Caixa: 0,
        OrdemPL: 1,
        Percentil: 0,
        IndexadorCota: "",
        TaxaAccrualCota: 0,
        DurationCota: 0,
        SubordinacaoContabilCota: null,
        ScoreRatingCota: 0,
        TaxaMTMCota: 0,
        SpreadMTMCota: 0,
        PDCota: 0,
        LGDCota: 0,
        EADCota: 0,
        PerdaEsperada: 0,
        CreditVaR: 0,
        CreditTailVaR: 0,
        CriadoEm: ""
    }]
    const [subordinationsState, setSubordinationsState] = useState(subordinationInitialState)

    useEffect(() => {
        loadContent()
    }, [])

    const validateDataProcessamento = () => {
        let errorMsg = ""

        if (!dataProcessamento) {
            errorMsg = "Data inválida"
        } else if (!dataReferencia || (!dataReferencia.value && !dataReferencia.raw)) {
            errorMsg = "Data Referência não encontrada"
        } else {
            const dataReferenciaBruta = dataReferencia.value || dataReferencia.raw || dataReferencia.show

            const dataProc = dayjs(dataProcessamento, [DATE_FORMAT, DATE_FORMAT_SHOW], true).startOf("day")
            const dataRef = dayjs(dataReferenciaBruta, [DATE_FORMAT, DATE_FORMAT_SHOW], true).startOf("day")
            const hoje = dayjs().startOf("day")

            if (!dataProc.isValid()) {
                errorMsg = "Data inválida"
            } else if (!dataRef.isValid()) {
                errorMsg = "Data Referência inválida"
            } else if (dataProc.isBefore(dataRef)) {
                errorMsg = "A Data Processamento deve ser maior ou igual à Data Referência"
            } else if (dataProc.isAfter(hoje)) {
                errorMsg = "A Data Processamento não pode ser posterior à data atual."
            }
        }

        setDataProcessamentoError(errorMsg)
        return errorMsg === "" ? true : errorMsg
    }

    // Cálculo do estoque
    useEffect(() => {
        if (!dadosCarregados) return
        const pddObs = typeof pddObservada === 'string' ? formatToFloat(pddObservada) : pddObservada
        const pddSug = typeof pddSugerida === 'string' ? formatToFloat(pddSugerida) : pddSugerida

        const novoValorPDD = typePDDObservada ? pddObs : pddSug
        setPddSelecionada(novoValorPDD)

        const volumeNum = typeof volumeFinanceiro === 'string' ? formatToFloat(volumeFinanceiro) : volumeFinanceiro
        const caixaNum = typeof caixa === 'string' ? formatToFloat(caixa) : caixa

        console.log("********** volumeFinanceiro:", volumeNum, "caixa:", caixaNum, "pdd", novoValorPDD, "estoque:", volumeNum + caixaNum - novoValorPDD)

        const novoEstoque = (parseFloat(volumeNum + caixaNum - novoValorPDD))
        setEstoque(novoEstoque)
        console.log("Estoque", estoque)
    }, [volumeFinanceiro, caixa, pddObservada, pddSugerida, typePDDObservada, dadosCarregados])

    // Cálculo do multiplicador
    useEffect(() => {
        if (!dadosCarregados) return

        // Se o denominador for 0, define como 1
        if (plCotas == 0 || plCotasOriginal === 0) {
            setMultiplicador(1)
            return
        }
        // Só recalcula se não foi editado manualmente
        if (!multiplicadorEditadoManualmente) {
            const novoMultiplicador = !typeSimuladorTaxaAccrual ? parseFloat((plCotas / plCotasOriginal).toFixed(4)) : 1
            setMultiplicador(novoMultiplicador)

            // Cálculo do Novo Caixa (caixa original * multiplicador)
            // Só recalcula se não foi editado manualmente
            if (!caixaEditadoManualmente) {
                const novoCaixa = novoMultiplicador * caixaOriginal
                const novoCaixaArredondadoo = parseFloat(novoCaixa.toFixed(2))
                setCaixa(novoCaixaArredondadoo)
            }
        }
        // Se foi editado manualmente, apenas garante que está como número
        else {
            const novoMultiplicador = typeof (multiplicador) === "string" ? parseFloat((multiplicador).toFixed(4)) : multiplicador
            setMultiplicador(novoMultiplicador)
            // Cálculo do Novo Caixa (caixa original * multiplicador)
            // Só recalcula se não foi editado manualmente
            if (!caixaEditadoManualmente) {
                const novoCaixa = novoMultiplicador * caixaOriginal
                const novoCaixaArredondadoo = parseFloat(novoCaixa.toFixed(2))
                setCaixa(novoCaixaArredondadoo)
            }
        }



    }, [plCotas, plCotasOriginal, multiplicador, caixaOriginal, multiplicadorEditadoManualmente, typeSimuladorTaxaAccrual, dadosCarregados])

    const handleMultiplicadorChange = (event) => {
        setMultiplicador(parseFloat(event.target.value) || 1)
        setMultiplicadorEditadoManualmente(true) // marca que foi feita uma edição manual no multiplicador
    }

    const handleCaixaChange = (formattedValue) => {
        setCaixa(formatToFloat(formattedValue)) // sempre numérico
        setCaixaEditadoManualmente(true) // marca que foi feita uma edição manual no caixa
    }

    const loadContent = () => {
        props.setLoading(true)
        service.getSelectSimulacao()
            .then((response) => {
                const { body } = response
                const selectList = body.map((item) => ({ value: item, description: `${item.Nome} - ${dayjs(item.CriadoEm).format(DATE_TIME_HOUR_MINUTE_FORMAT_SHOW)}` }))
                setSelectItemList(selectList)
            })
            .catch(() => {
            }).finally(() => {
                props.setLoading(false)
            })
    }

    const setSelect = (value) => {
        props.setLoading(true)
        setLoadingTable(true)
        const { uuid, Nome } = value

        service.loadLoteSelecionado(uuid)
            .then((response) => {
                const { body } = response
                const { union_data } = body
                const { dados_carteira_entrada_original } = body
                const { DataReferenciaNovo, VolumeFinanceiroNovo, QuantidadeOperacoesNovo, PDDManutencao, PDDObservada } = union_data[0]

                if (dados_carteira_entrada_original.length > 0) {
                    console.log("dados_carteira_entrada_original:", dados_carteira_entrada_original)
                    const newSubordinationState = dados_carteira_entrada_original
                        .map((item, index) => ({ ...item, id: index + 1, PLCota: formatToFloat(item.PLCota) }))
                        .sort((a, b) => a.OrdemPL - b.OrdemPL)
                    const plInputList = newSubordinationState.map((item) => ({ id: item.id, PLCota: item.PLCota }))

                    const { Caixa, Percentil } = dados_carteira_entrada_original[0] // Carrega o caixa original

                    setCaixa(Number(Caixa))
                    // setCaixa(changeFormatedValue(formatStringToFloatDecimalCase(Caixa)))
                    setCaixaOriginal(Number(Caixa))

                    setPercentil(Percentil)
                    setPlInput(plInputList)
                    setSubordinationsState(newSubordinationState)
                    sumPlCotas(newSubordinationState)



                    const plOriginal = newSubordinationState.reduce(
                        (acc, item) => acc + formatToFloat(item.PLCota), 0)
                    setPlCotasOriginal(plOriginal)   // setter recebe o valor original que é a soma dos plCotas originais
                    setDadosCarregados(true)


                } else {
                    setCaixa(0)
                    setCaixaOriginal(0)
                    setPLCotas(0)
                    setPlCotasOriginal(0)
                    setPlInput([])
                    setSubordinationsState(subordinationInitialState)
                }

                setSelectValue(value)
                setNomeCarteira(Nome)
                setDataReferencia({ value: DataReferenciaNovo, show: dayjs(DataReferenciaNovo).format(DATE_FORMAT_SHOW), raw: DataReferenciaNovo })
                setVolumeFinanceiro(changeFormatedValue(formatStringToFloatDecimalCase(VolumeFinanceiroNovo)))
                setQtdOperacoes(QuantidadeOperacoesNovo)
                setPddObservada(changeFormatedValue(formatStringToFloatDecimalCase(PDDObservada)))
                setPddSugerida(changeFormatedValue(formatStringToFloatDecimalCase(PDDManutencao)))
                setMultiplicadorEditadoManualmente(false)
                setCaixaEditadoManualmente(false)
            })
            .catch(() => {
            }).finally(() => {
                setLoadingTable(false)
                props.setLoading(false)
            })

        setSelectValue(value)
        if (value === "") return
    }

    const sumPlCotas = (list) => {
        const sum = list.reduce((acc, item) => {
            const value = formatToFloat(item.PLCota)
            return acc + (isNaN(value) ? 0 : value)
        }, 0)

        setPLCotas(sum)
    }

    const addSubordinacao = () => {
        setSubordinationsState((prevState) => {
            const lastOrdemPL = prevState[prevState.length - 1].OrdemPL
            const nextOrdemPL = lastOrdemPL + 1

            const novaLinha = {
                id: nextOrdemPL,
                ID: nextOrdemPL,
                IDCarteiraLote_id: "",
                IDOperacao: "",
                DataReferencia: "",
                DataProcessamento: dayjs().format(DATE_FORMAT_SHOW),
                NomeCota: `Subordinação ${nextOrdemPL}`,
                PLCota: "0,00",
                Caixa: 0,
                OrdemPL: nextOrdemPL,
                Percentil: 0,
                IndexadorCota: "",
                TaxaAccrualCota: 0,
                DurationCota: 0,
                SubordinacaoContabilCota: null,
                ScoreRatingCota: 0,
                TaxaMTMCota: 0,
                SpreadMTMCota: 0,
                PDCota: 0,
                LGDCota: 0,
                EADCota: 0,
                PerdaEsperada: 0,
                CreditVaR: 0,
                CreditTailVaR: 0,
                CriadoEm: ""
            }

            // Atualiza o plInput também
            setPlInput((prevInput) => [
                ...prevInput,
                { id: nextOrdemPL, PLCota: 0 }
            ])

            return [...prevState, novaLinha]
        })
    }

    const cleanSubordinations = () => {
        setSubordinationsState(subordinationInitialState)
        setPlInput([])
        setPercentil(percentilDefaultValue)
        setCaixa(caixaDefaultValue)
        setMultiplicador(multiplicadorDefaultValue)
        setPLCotas(plCotasDefaultValue)
        setPercentil(percentilDefaultValue)
        setTableKey(Math.random())
        setDataProcessamento(dataProcessamentoDefaultValue)
    }

    const handleSubordinationChange = (field, id, value) => {
        if (field === 'PLCota') {
            const valueNumber = typeof value === 'string' ? formatToFloat(value) : value

            const editPlInputList = plInput.filter(input => input.id !== id)
            const plInputList = [...editPlInputList, { id, PLCota: valueNumber }]
            setPlInput(plInputList)
            sumPlCotas(plInputList)

            setSubordinationsState(prevState => prevState.map(subordination =>
                subordination.id === id
                    ? { ...subordination, [field]: valueNumber } // ← aqui usa o número diretamente
                    : subordination
            )
            )
            return
        }

        let valueFormatted = formatDecimalCaseReplaceDot(value)
        if (field == 'OrdemPL') {
            valueFormatted = parseInt(valueFormatted)
        }

        setSubordinationsState(prevState => prevState.map(subordination => {
            return subordination.id === id ? { ...subordination, [field]: valueFormatted } : subordination
        }))
    }

    const validaTaxaDecrescente = () => {
        return subordinationsState.every((item, index, array) => {
            if (index === 0) return true // primeiro sempre passa
            return Number(item.TaxaAccrualCota) < Number(array[index - 1].TaxaAccrualCota)
        })
    }

    const handleRemoveSubordination = (id) => {
        if (subordinationsState.length < 2) return
        const list = subordinationsState.filter(item => item.id !== id)
        const editPlInputList = plInput
            .filter(input => input.id !== id)
            .map(input => ({
                ...input,
                PLCota: typeof input.PLCota === 'string' ? formatToFloat(input.PLCota) : input.PLCota
            }))
        setSubordinationsState(list)
        sumPlCotas(editPlInputList)
        setPlInput(editPlInputList)
    }

    const validaForm = () => {
        const validField = (campo, mensagem) => validaPreenchimentoCampo(campo, mensagem, props.openAlert)

        if (!validField(nomeCarteira, "Necessário informar o nome da Carteira", "warning")) return false
        if (!validField(percentil, "Necessário informar o Percentil", "warning")) return false
        if (!validField(caixa, "Necessário informar a Caixa", "warning")) return false

        if (typeSimuladorTaxaAccrual) {
            if (!validField(multiplicador, "Necessário informar o Multiplicador", "warning")) return false
        }

        return true
    }

    // IMPORTANTE: dataProcessamento será passado como o valor para a chave data_referencia do payload
    const postSimulacao = () => {
        if (selectValue === undefined || selectValue === "") {
            return props.openAlert("Selecione um lote de operações para realizar a simulação", "warning")
        }

        if (!validaForm()) {
            return
        }

        const validData = validateDataProcessamento()
        if (validData !== true) {
            try {
                if (dataProcessamentoRef && dataProcessamentoRef.current && typeof dataProcessamentoRef.current.focus === 'function') {
                    dataProcessamentoRef.current.focus()
                }
            } catch (e) {
                // ignore
            }
            return
        }

        const tipoSimulacao = typeSimuladorTaxaAccrual ? "taxa" : "subordinacao"

        // Normaliza os PLCota em um array de números
        const valoresPl = subordinationsState
            .map(item => {
                if (typeof item.PLCota === "string") {
                    return parseFloat(item.PLCota.replace(",", "."))
                }
                return Number(item.PLCota || 0)
            })
            
        // Normaliza dataProcessamento para o formato que o backend espera
        const dataProcessamentoFormatada = dayjs(
            dataProcessamento,
            DATE_FORMAT_SHOW
        ).format("YYYY-MM-DD")

        const dataReferenciaOriginalFormatada = dayjs(
            dataReferencia.value || dataReferencia.raw,
            ["YYYY-MM-DD", DATE_FORMAT_SHOW]
        ).format("YYYY-MM-DD")

       const dataReferenciaOriginal = dataReferenciaOriginalFormatada

        const plCotas = valoresPl.reduce((a, b) => a + b, 0)

        const existePLMenorOuIgualZero = valoresPl.some(pl => pl <= 0)

        if (tipoSimulacao == 'subordinacao' && plCotas <= 0) {
            props.openAlert("Informe PL de Cotas maiores que zero", "warning")
            return
        }

        if (tipoSimulacao == 'subordinacao' && existePLMenorOuIgualZero) {
            props.openAlert("Informe um PL para cada uma das cota ou exclua a linha de PLCota igual a zero da lista", "warning")
            return
        }

        const hasDuplicates = subordinationsState.some((item, index, self) =>
            self.findIndex(i => i.OrdemPL === item.OrdemPL) !== index
        )
        if (hasDuplicates) {
            props.openAlert("Há valores duplicados em OrdemCota", "warning")
            return
        }

        let taxaValida = validaTaxaDecrescente()
        if (!taxaValida && tipoSimulacao == 'taxa') {
            console.log("taxa invalida")
            props.openAlert("Não tem solução para o cenário solicitado. As taxas devem ser em ordem decrescente entre as cotas de maior e menor subordinação.", "warning")
            return
        }

        props.setLoading(true)
        // IMPORTANTE: dataProcessamentoFormatada é passado como o valor para a chave data_referencia no payload
        service.postSimulacao(
            selectValue.uuid,
            nomeCarteira,
            dataReferenciaOriginal,
            dataProcessamentoFormatada,
            caixa,
            percentil,
            plCotas,
            multiplicador,
            tipoSimulacao,
            qtdOperacoes,
            pddSelecionada,
            typePDDObservada ? "observada" : "sugerida",
            subordinationsState
        ).then((response) => {
            const { body } = response
            const { nome_carteira, caixa, percentil, result } = body  // Carrega o caixa original com o nome 'caixa'

            setNomeCarteira(nome_carteira)
            setPercentil(percentil)
            setMultiplicador(multiplicador)
            console.log(caixa)

            if (result.length > 0) {
                setBodySimulacao(result)
                const newSubordinationState = result
                    .map((item) => ({ ...item, id: item.OrdemCota, PLCota: item.PLCota, OrdemPL: item.OrdemCota }))
                    .sort((a, b) => parseInt(a.OrdemCota) - parseInt(b.OrdemCota))
                setSubordinationsState(newSubordinationState)
                setTableKey(Math.random())

                const plInputList = newSubordinationState.map((item) => ({ id: item.id, PLCota: item.PLCota }))
                setPlInput(plInputList)
                sumPlCotas(newSubordinationState)
            }

            props.openAlert("Simulação executada com sucesso", "success")
        }).catch((err) => {
            try {
                const json = JSON.stringify(err)
                const { response } = JSON.parse(json)
                const { body } = response
                const { error } = body
                props.openAlert(error, "error")
            } catch (error) {
                props.openAlert("Erro ao realizar a simulacão", "error")
            }
        }).finally(() => {
            props.setLoading(false)
        })
    }

    const saveSimulation = () => {
        const tipoSimulacao = typeSimuladorTaxaAccrual ? "taxa" : "subordinacao"

        const dataReferenciaOriginal = dayjs(
            dataReferencia.value || dataReferencia.raw,
            ["YYYY-MM-DD", DATE_FORMAT_SHOW]
        ).format("YYYY-MM-DD")

        const dataProcessamentoFormatada = dayjs(
            dataProcessamento,
            DATE_FORMAT_SHOW
        ).format("YYYY-MM-DD")

        if (selectValue === undefined || selectValue === "") {
            return props.openAlert("Selecione um lote de operações para realizar a simulação", "warning")
        }

        if (plCotas <= 0) {
            return props.openAlert("Informe PL de Cotas maiores que zero", "warning")
        }

        console.log(caixa)

        props.setLoading(true)
        // Importante: se analizar o back vemos que a data referencia que é usada lá é a que vem[...] 
        // [...] do bodySimulacao ou seja o valor da data processamento preenchida e não o da referencia
        service.saveSimulation(
            selectValue.uuid,
            nomeCarteira,
            dataReferenciaOriginal,
            dataProcessamentoFormatada,
            caixa,
            percentil,
            plCotas,
            plTotal,
            multiplicador,
            volumeFinanceiro,
            pddObservada,
            pddSugerida,
            tipoSimulacao,          
            qtdOperacoes,           
            pddSelecionada,
            bodySimulacao,
        ).then((response) => {
            const { body } = response
            console.log(body)
            props.openAlert("Simulação salva com sucesso", "success")
        }).catch(() => {
            props.openAlert("Houve um erro ao salvar a simulação, tente novamente", "error")
        }).finally(() => {
            props.setLoading(false)
        })
    }

    const getGrayClass = () => {
        if (typeSimuladorTaxaAccrual) {
            return "gray-cell"
        }

        return ""
    }

    const caixaNumber = formatToNumber(caixa)
    const volumeFinanceiroNumber = formatToNumber(volumeFinanceiro)
    const plTotal = caixaNumber + volumeFinanceiroNumber

    return <>
        <Grid container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={4} >
            <Grid item sm={12} md={6} xl={3} xs={12}>
                <SelectValue
                    label={"Selecionar"}
                    value={selectValue}
                    id="select"
                    changeValue={setSelect}
                    options={selectItemList} />
            </Grid>
            <Grid item sm={12} md={6} xl={4} xs={12}>
                <ToggleButtonSelect leftLabel={"Simulação por Índice Subordinação"} rightLabel={"Taxa Accrual"} value={typeSimuladorTaxaAccrual} onChange={setTypeSimuladorTaxaAccrual} />
            </Grid>
        </Grid>
        <br /><br />

        <Grid container direction="row" justifyContent="flex-start" alignItems="center" spacing={4}>
            <Grid item sm={12} md={6} xl={2} xs={12}>
                <TextFieldFormatCurrency label={"Data Referência"} value={dataReferencia.show} onChange={setDataReferencia} variant="outlined" readOnly={true} focused={true} />
            </Grid>
            <Grid item sm={12} md={6} xl={2} xs={12}>
                <TextFieldFormatCurrency label={"Volume Financeiro"} value={volumeFinanceiro} onChange={setVolumeFinanceiro} variant="outlined" readOnly={true} focused={true} />
            </Grid>
            <Grid item sm={12} md={6} xl={2} xs={12}>
                <TextFieldFormatCurrency label={"PDD Observada"} value={pddObservada} onChange={setPddObservada} variant="outlined" readOnly={true} focused={true} />
            </Grid>
            <Grid item sm={12} md={6} xl={2} xs={12}>
                <TextFieldFormatCurrency label={"PDD Sugerida"} value={pddSugerida} onChange={setPddSugerida} variant="outlined" readOnly={true} focused={true} />
            </Grid>
            <Grid item sm={12} md={6} xl={2} xs={12}>
                <TextFieldFormatCurrency label={"Quantidade Operações"} value={qtdOperacoes} onChange={setQtdOperacoes} variant="outlined" readOnly={true} focused={true} />
            </Grid>
            <Grid item sm={12} md={6} xl={2} xs={12}>
                <TextFieldFormatCurrency label={"PL Cotas"} value={Number(plCotas).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} onChange={setPLCotas} variant="outlined" readOnly={true} focused={true} />
            </Grid>
            <Grid item sm={12} md={6} xl={2} xs={12}>
                <TextFieldFormatDate
                    label="Data Processamento"
                    value={dataProcessamento}
                    onChange={handleDataProcessamentoChange}
                    error={!!dataProcessamentoError}
                    helperText={dataProcessamentoError}
                    FormHelperTextProps={{ style: { marginLeft: 0 } }}
                    inputRef={dataProcessamentoRef}
                />
            </Grid>
            <Grid item sm={12} md={6} xl={4} xs={12}>
                <ToggleButtonSelect leftLabel={"PDDSugerida"} rightLabel={"PDDObservada"} value={typePDDObservada} onChange={setTypePDDObservada} />
            </Grid>
        </Grid>
        <br /><br />

        <Grid container direction="row" justifyContent="flex-start" alignItems="center" spacing={4}>
            <Grid item sm={12} md={3} xl={3} xs={12}>
                <TextField
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    value={nomeCarteira}
                    onChange={(event) => setNomeCarteira(event.target.value)}
                    label="Nome da Carteira"
                    variant="standard" />
            </Grid>

            <Grid item sm={12} md={1.5} xl={1.5} xs={12}>
                <TextField
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    value={multiplicador}
                    onChange={handleMultiplicadorChange}
                    label="Multiplicador"
                    type={"number"}
                    variant="standard"
                />
            </Grid>

            <Grid item sm={12} md={1.5} xl={1.5} xs={12}>
                <TextField
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    value={percentil}
                    onChange={(event) => setPercentil(event.target.value)}
                    label="Percentil"
                    type={"number"}
                    variant="standard" />
            </Grid>
            <Grid item sm={12} md={3} xl={3} xs={12}>
                <TextFieldFormatCurrency
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    label="Caixa"
                    // value={caixa}
                    value={Number(caixa).toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}
                    onChange={handleCaixaChange}
                    variant="standard"
                />
            </Grid>
            <Grid item sm={12} md={3} xl={3} xs={12}>
                <TextFieldFormatCurrency
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    label="PL Total"
                    value={plTotal.toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                    })}
                    variant="standard"
                    readOnly={true}
                />
            </Grid>
        </Grid>

        <br /><br />

        {loadingTable ? <SkeletonTable /> :
            <>
                <Paper>
                    <DataGrid
                        key={tableKey}
                        autoHeight
                        autoPageSize={false}
                        showColumnVerticalBorder
                        showCellVerticalBorder
                        hideFooter
                        rows={subordinationsState}
                        columns={[
                            {
                                field: 'OrdemPL',
                                headerName: 'Ordem Cota',
                                align: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                flex: true,
                                minWidth: 100,
                                headerAlign: "center",
                                renderCell: ({ id, value }) => <EditableInput
                                    editable={true}
                                    fieldValue={value}
                                    handleChange={(cellValue) => handleSubordinationChange('OrdemPL', id, cellValue)}
                                />,
                            },
                            {
                                field: 'NomeCota',
                                headerName: 'Nome da Cota',
                                align: "center",
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                flex: true,
                                minWidth: 180,
                                renderCell: ({ id, value }) => <EditableInput
                                    editable={true}
                                    fieldValue={value}
                                    handleChange={(cellValue) => handleSubordinationChange('NomeCota', id, cellValue)}
                                />,
                            },
                            {
                                field: 'PLCota',
                                headerName: 'PL da Cota',
                                align: "center", headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                type: 'number',
                                flex: 1,
                                cellClassName: getGrayClass,
                                minWidth: 180,
                                renderCell: ({ id, value }) => {
                                    const numericValue = typeof value === 'string'
                                        ? parseFloat(value.replace(/\./g, '').replace(',', '.'))
                                        : value

                                    return (
                                        <EditableNumberInput
                                            editable={!typeSimuladorTaxaAccrual}
                                            fieldValue={numericValue.toLocaleString('pt-BR', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })}
                                            handleChange={(cellValue) =>
                                                handleSubordinationChange('PLCota', id, formatToFloat(cellValue))
                                            }
                                        />
                                    )
                                }
                            },
                            {
                                field: 'IndexadorCota',
                                headerName: 'Indexador',
                                align: "center", headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                flex: 1,
                                minWidth: 180,
                                renderCell: ({ id, value }) => <EditableInput
                                    editable={true}
                                    fieldValue={value}
                                    handleChange={(cellValue) => handleSubordinationChange('IndexadorCota', id, cellValue)}
                                />,
                            },
                            {
                                field: 'TaxaAccrualCota',
                                headerName: 'TaxaAccrual',
                                align: "center",
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                flex: 1,
                                minWidth: 180,
                                cellClassName: () => {
                                    if (!typeSimuladorTaxaAccrual) {
                                        return "gray-cell"
                                    } else return ""
                                },
                                renderCell: ({ id, value }) => <EditableNumberInput
                                    editable={typeSimuladorTaxaAccrual}
                                    fieldValue={formatStringToFloatDecimalCase(value)}
                                    handleChange={(cellValue) => handleSubordinationChange('TaxaAccrualCota', id, cellValue)}
                                />,
                            },
                            {
                                field: 'DurationCota',
                                headerName: 'DurationCota',
                                align: "center", headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                flex: 1,
                                type: 'number',
                                minWidth: 180,
                                renderCell: ({ id, value }) => <EditableInput
                                    editable={true}
                                    fieldValue={value}
                                    handleChange={(cellValue) => handleSubordinationChange('DurationCota', id, cellValue)}
                                />,
                            },
                            {
                                field: 'SubordinacaoContabilCota',
                                headerName: 'Subordinação',
                                align: "center", headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                flex: 1,
                                minWidth: 180,
                                cellClassName: 'gray-cell',
                                renderCell: (params) => formatStringToFloatDecimalCase(params.value)
                            },
                            {
                                field: 'RatingCarteira',
                                headerName: 'Rating',
                                align: "center", headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                flex: 1,
                                minWidth: 180,
                                cellClassName: 'gray-cell',
                            },
                            {
                                field: 'TaxaMTMCota',
                                headerName: 'Taxa MTM',
                                align: "center", headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                flex: 1,
                                minWidth: 180,
                                cellClassName: 'gray-cell',
                                renderCell: (params) => formatStringToFloatDecimalCase(params.value)
                            },
                            {
                                field: 'SpreadMTMCota',
                                headerName: 'Spread',
                                align: "center", headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                flex: 1,
                                minWidth: 180,
                                cellClassName: 'gray-cell',
                                renderCell: (params) => formatStringToFloatDecimalCase(params.value)
                            },
                            {
                                field: 'PDCota',
                                headerName: 'PD',
                                align: "center", headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                flex: 1,
                                minWidth: 180,
                                cellClassName: 'gray-cell',
                                renderCell: (params) => formatStringToFloatDecimalCase(params.value)
                            },
                            {
                                field: 'LGDCota',
                                headerName: 'LGD',
                                align: "center", headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                flex: 1,
                                minWidth: 180,
                                cellClassName: 'gray-cell',
                                renderCell: (params) => formatStringToFloatDecimalCase(params.value)
                            },
                            {
                                field: 'EADCota',
                                headerName: 'EAD',
                                align: "center", headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                flex: 1,
                                minWidth: 180,
                                cellClassName: 'gray-cell',
                                renderCell: (params) => formatStringToFloatDecimalCase(params.value)
                            },
                            {
                                field: 'PerdaEsperada',
                                headerName: 'Perda Esperada',
                                align: "center", headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                flex: 1,
                                minWidth: 180,
                                cellClassName: 'gray-cell',
                                renderCell: (params) => formatStringToFloatDecimalCase(params.value)
                            },
                            {
                                field: 'CreditVaRCota',
                                headerName: 'Credit VaR',
                                align: "center", headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                flex: 1,
                                minWidth: 180,
                                cellClassName: 'gray-cell',
                                renderCell: (params) => formatStringToFloatDecimalCase(params.value)
                            },
                            {
                                field: 'CreditTailVaRCota',
                                headerName: 'Credit Tail VaR',
                                align: "center", headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                flex: 1,
                                minWidth: 180,
                                cellClassName: 'gray-cell',
                                renderCell: (params) => formatStringToFloatDecimalCase(params.value)
                            },
                            {
                                field: '',
                                headerName: 'Excluir',
                                align: "center", headerAlign: "center",
                                minWidth: 80,
                                renderCell: (params) => (
                                    <Button onClick={() => handleRemoveSubordination(params.row.id)} color="error" align="center">
                                        <DeleteOutlineOutlinedIcon />
                                    </Button>
                                ),
                            }
                        ]}
                        disableRowSelectionOnClick
                    />
                </Paper>

                <br />
                <Grid container direction={"row"} alignContent={"center"} justifyContent={"center"}>
                    <Grid container justifyContent={"space-between"}>
                        <Grid item>
                            <Grid container spacing={1} justifyContent={"flex-start"}>
                                <Grid item>
                                    <Button onClick={addSubordinacao} variant="contained">
                                        <Tooltip title="Adicione as cotas de subordinação da sua carteira, quantas forem necessárias">
                                            + Subordinação
                                        </Tooltip>
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container spacing={1} justifyContent={"flex-end"}>
                                <Grid item>
                                    <Button variant="contained" onClick={cleanSubordinations}>Limpar</Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" onClick={() => {
                                        postSimulacao()
                                    }}>Simular</Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" onClick={() => {
                                        saveSimulation()
                                    }}>Salvar</Button>
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>
            </>
        }
    </>
}

SimuladorSubordinacaoSimulacao.propTypes = {
    setLoading: PropTypes.func,
    openAlert: PropTypes.func,
}

export default SimuladorSubordinacaoSimulacao
